import React from 'react';

const NoRecords = (props) => (
    <tr>
        <td colSpan="100%">
            No records available...
        </td>
    </tr>
);

export default NoRecords;